"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Fabric = void 0;
var Utilities_1 = require("../../Utilities");
var Fabric_base_1 = require("./Fabric.base");
var Fabric_styles_1 = require("./Fabric.styles");
/**
 * @deprecated This component is deprecated as of `@fluentui/react` version 8. Use `ThemeProvider` instead.
 */
exports.Fabric = (0, Utilities_1.styled)(Fabric_base_1.FabricBase, Fabric_styles_1.getStyles, undefined, {
    scope: 'Fabric',
});
//# sourceMappingURL=Fabric.js.map